import { createAsyncThunk } from '@reduxjs/toolkit'

import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'
import {
  getOjtSlotListApi,
  postOjtSlotApi,
  postOjtSlotOffDayApi,
  type GetOjtSlotQueryParamsType,
  type PostOjtSlotPayloadType,
  type PostOjtSlotOffDayPayloadType,
} from 'features/Enterprise/Schedules/services/ojtSlotting'

import formatRoleName from '../../pages/OJTSlotting/helpers/formatRoleName'
import {
  sliceName,
  setLoading,
  setDialogState,
  setOjtSlotList,
  setPagination,
  setRoleOffDay,
  setOffDayOjtSlotList,
} from './ojtSlottingSlice'

export const getOjtSlotList = createAsyncThunk(
  `${sliceName}/getOjtSlotList`,
  async (params: GetOjtSlotQueryParamsType, { dispatch }) => {
    try {
      dispatch(setLoading(true))
      const { data } = await getOjtSlotListApi(params)
      dispatch(setOjtSlotList(data.data))
      dispatch(setPagination({ ...data.pagination, page_size: params.page_size || '10' }))
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)

export const postOjtSlot = createAsyncThunk(
  `${sliceName}/postOjtSlot`,
  async (data: PostOjtSlotPayloadType, { dispatch, getState }) => {
    try {
      const {
        ojtSlotting: { pagination },
      } = getState() as StoreStateType
      dispatch(setLoading(true))
      await postOjtSlotApi(data)
      dispatch(
        getOjtSlotList({
          page_size: pagination.page_size,
          location_id: data.location_id,
        }),
      )
      dispatch(setDialogState({ type: '' }))
      toastSuccess('Kamu berhasil submit OJT Slotting ')
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)

export const postDayOffOjtSlot = createAsyncThunk(
  `${sliceName}/postDayOffOjtSlot`,
  async (data: PostOjtSlotOffDayPayloadType, { dispatch }) => {
    try {
      dispatch(setLoading(true))
      await postOjtSlotOffDayApi(data)
      dispatch(setRoleOffDay({ role: data.role, off_day: data.off_day }))
      toastSuccess(`Setting Off Day untuk role ${formatRoleName(data.role)} berhasil`)
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)

export const getOffDayOjtSlotList = createAsyncThunk(
  `${sliceName}/getOffDayOjtSlotList`,
  async (params: GetOjtSlotQueryParamsType, { dispatch }) => {
    try {
      dispatch(setLoading(true))
      const { data } = await getOjtSlotListApi(params)
      dispatch(setOffDayOjtSlotList(data.data?.[0]?.off_day || []))
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)
